export const state = () => ({
    darkLayerEnabled: false
});

export const getters = {
    darkLayerEnabled: state => state.darkLayerEnabled
};

export const mutations = {
    SET_DARK_LAYER_ENABLED(state, newValue) {
        state.darkLayerEnabled = newValue;
    }
};

export const actions = {
    setDarkLayerEnabled({commit}, state) {
        commit('SET_DARK_LAYER_ENABLED', state);
    }
};

export default {state, getters, mutations, actions}
